import { createStore } from 'vuex';

export const store = createStore({
  state: {
    menu: {
      isOpen: false,
      loading: false,
      error: null,
      success: null
    },
  },

  mutations: {

    SET_LOADING(state, isLoading) {
      state.loading = isLoading;
    },

    SET_MENU_STATE(state, payload) {
      state.menu.isOpen = payload;
    },

    SET_MENU_ERROR(state, payload) {
      state.menu.error = payload;
    },

    SET_MENU_SUCCESS(state, payload) {
      state.menu.success = payload;
    }
  },

  actions: {
    toggleMenu({ commit, state }) {
      commit('SET_MENU_STATE', !state.menu.isOpen);
    },

    startLoading({ commit }) {
      commit('SET_LOADING', true);
    },

    stopLoading({ commit }) {
      commit('SET_LOADING', false);
    },

    setMenuError({ commit }, payload) {
      commit('SET_MENU_ERROR', payload);
    },

    setMenuSuccess({ commit }, payload) {
      commit('SET_MENU_SUCCESS', payload);
    }
  },
});


// Muestra las alertas en el navegador
let intervalId = setInterval(checkAlerts, 1000);
import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css';
async function checkAlerts() {
  const alerts = JSON.parse(localStorage.getItem('alerts') || '[]') || [];
  const alert = alerts[0];
  if (!alert) {
    return;
  }

  clearInterval(intervalId);
  const result = await Swal.fire({
    text: alert.message,
    icon: alert.type,
    showCancelButton: false,
    confirmButtonColor: '#3085d6',
    confirmButtonText: 'Aceptar',
  })
  if (result.isConfirmed) {
    alerts.shift();
    localStorage.setItem('alerts', JSON.stringify(alerts));
    intervalId = setInterval(checkAlerts, 1000);
  }
}